import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';

export const routes: Routes = [

  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'ecosystem',
    loadComponent: () => import('./components/ecosystem/ecosystem.component').then(m => m.EcosystemComponent)
  },
  {
    path: 'services',
    loadComponent: () => import('./components/services/services.component').then(m => m.ServicesComponent)
  },
  {
    path: 'gallery',
    loadComponent: () => import('./components/gallery/gallery.component').then(m => m.GalleryComponent),
    title: 'Product Gallery | Vettro Traders'
  },
  {
    path: 'contact',
    loadComponent: () => import('./components/contact/contact').then(m => m.ContactComponent),
    title: 'Contact & Quote | Vettro Traders'
  },


  {
    path: 'reviews',
    loadComponent: () => import('./components/reviews/reviews.component').then(m => m.ReviewsComponent),
    title: 'Customer Reviews & Location | Vettro Traders'
  },

  {
    path: '**',
    loadComponent: () => import('./components/not-found/not-found').then(m => m.NotFound),
    title: 'Page Not Found | Vettro Traders'
  }
];